import { render, staticRenderFns } from "./animalBtn.vue?vue&type=template&id=1ec4f57b&scoped=true&"
import script from "./animalBtn.vue?vue&type=script&lang=js&"
export * from "./animalBtn.vue?vue&type=script&lang=js&"
import style0 from "./animalBtn.vue?vue&type=style&index=0&id=1ec4f57b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4f57b",
  null
  
)

export default component.exports